import React from 'react';
import styles from './Events.module.css';

const events = [
  {
    name: 'JLW Connect 2026',
    href: 'https://www.jlwconnect2026.org',
    description:
      'A premier global leadership and wellness networking summit, bringing together visionaries and change-makers from diverse industries to inspire, connect, and lead the future.'
  },
  {
    name: 'Atlas Events',
    href: 'https://atlasevents.in',
    description:
      'A curated events platform crafting unique experiences across arts, culture, business, and community-driven gatherings that leave a lasting and memorable impact.'
  },
  {
    name: 'Orbix 8',
    href: 'https://orbix8.com',
    description:
      'The eighth edition of Orbix — a flagship innovation and technology summit celebrating breakthroughs in digital transformation and the next wave of emerging solutions.'
  },
  {
    name: 'DIDC F27',
    href: 'https://www.didcf27.com/',
    description:
      "The annual gathering where Diageo India's Commercial, Marketing, and Leadership teams align on strategy, celebrate achievement, and set the agenda for the year ahead."
  },
  {
    name: 'Demand Conference 27',
    href: 'https://www.didcf27.com/',
    description:
      "The annual gathering where Diageo India's Commercial, Marketing, and Leadership teams align on strategy, celebrate achievement, and set the agenda for the year ahead."
  },
  {
    name: 'Hindu Economic Forum',
    href: 'https://hindueconomicforumkolkata.com/',
    description:
      "A select gathering of over 200 leaders from industry, government and public policy, along with next-generation entrepreneurs and thought leaders, to exchange ideas, foster collaboration and catalyse Bengal's next phase of economic growth."
  },
  {
    name: 'JCP THE GRAND FINALE',
    href: 'http://jcpthegrandfinale.com/',
    description:
      'The most spectacular culmination of JITO Chennai Plus. An evening of celebration, recognition, and connection — bringing together 1000+ leaders for an unforgettable Grand Finale.'
  }
];

const Events = () => {
  return (
    <div className={styles.container} id="events">
      <div className={styles.content}>
        <div className={styles.headingBox}>
          <span className={`titleText ${styles.sectionTitle}`}>
            EVENTS WE HAVE DONE
          </span>
        </div>
        <div className={styles.cardsRow}>
          {events.map((event) => (
            <div className={styles.card} key={event.name}>
              <a
                href={event.href}
                className={`headingNormalText ${styles.eventLink}`}
                target="_blank"
                rel="noopener noreferrer">
                {event.name}
              </a>
              <p className={`bodyText ${styles.eventDescription}`}>
                {event.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Events;
